export const itemStyle = {
    fontSize: '18px',
    lineHeight: '18px',
};
